module.exports = __webpack_public_path__ + "Flama-ExtraboldItalic.woff2?f89c0a96f6ae654c13656b424f540a92";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-ExtraboldItalic.woff2
// module id = 899
// module chunks = 0